// extracted by mini-css-extract-plugin
export var header = "header-module--header--2ea3u";
export var logo = "header-module--logo--3gIix";
export var logoIcon = "header-module--logo-icon--1rrUJ";
export var logoText = "header-module--logo-text--T2bdz";
export var mainNav = "header-module--main-nav--1gjeh";
export var focus = "header-module--focus--22NJm";
export var scrolled = "header-module--scrolled--plmZY";
export var mainNavContainer = "header-module--main-nav-container--1cxzg";